import http from './public'
import * as apiWap from './wap'
export const getProductWapBase = apiWap.getProductWapBase
export const getWapDesigns = apiWap.getWapDesigns
export const getWapFavoriteInfo = apiWap.getWapFavoriteInfo
export const getWapPriceAndStock = apiWap.getWapPriceAndStock
import * as apiAiCreate from './aiCreate'

// 登陆
export const userLogin = (params) => {
  // return http.fetchPost('/picSearch/wes/customer/login', params)
  return http.fetchPost('/picSearch/wes/account/login', params)
}
// 退出登陆
export const loginOut = (params) => {
  return http.fetchGet('/picSearch/wes/customer/loginOut', params)
}
// 用户信息
export const userInfo = (params) => {
  return http.fetchGet('/picSearch/wes/customer/showInfo', params)
  // return http.fetchGet('/front/member/checkLogin', params)
}
export const getUserInfo = (params) => {
  return http.fetchPost('/picSearch/wes/customer/getCustomerById', params)
}
// 注册账号
export const register = (params) => {
  return http.fetchPost('/picSearch/wes/customer/register', params)
  // return http.fetchPost('/front/member/register', params)
}
// 获取子菜单
export const getMenuChildren = (params) => {
  return http.fetchPost('/picSearch/wes/menu/getMenuChildren', params)
}
export const getDesignMenuChildren = (params) => {
  return http.fetchPost('/picSearch/wes/design-menu/getMenuChildren', params)
}
// 获取菜单名称
export const getMenuName = (params) => {
  return http.fetchPost('/picSearch/wes/menu/getMenuName', params)
}
export const getDesignMenuName = (params) => {
  return http.fetchPost('/picSearch/wes/design-menu/getMenuName', params)
}
// h获取菜单
export const getFrontMenu = (params) => {
  return http.fetchPost('/picSearch/wes/menu/getFrontMenu', params)
  // return http.fetchPost('/front/member/register', params)
}
export const getFrontDesignMenu = (params) => {
  return http.fetchPost('/picSearch/wes/design-menu/getFrontMenu', params)
  // return http.fetchPost('/front/member/register', params)
}
export const getStyle3dToken = () => {
  return http.fetchGet('/picSearch/wes/design/getStyle3dToken')
  // return http.fetchPost('/front/member/register', params)
}

export const getChanelMenu = (params) => {
  return http.fetchPost('/picSearch/wes/chanel/getChanelMenu', params)
  // return http.fetchPost('/front/member/register', params)
}
// 上传图片
export const upload = (params) => {
  return http.fetchPost('/front/member/imgaeUpload', params)
}
// 修改头像
export const updateheadimage = (params) => {
  return http.fetchPost('/front/member/updateheadimage', params)
}
// 捐赠列表
export const thanksList = (params) => {
  return http.fetchGet('/front/member/thanks', params)
}
// 首页接口
export const productHome = (params) => {
  return http.fetchGet('/front/goods/home', params)
}
// 首页接口
export const navList = (params) => {
  return http.fetchGet('/front/goods/navList', params)
  // return http.fetchGet('/picSearch/wes/menu/getFrontMenu', params)
}
// 推荐板块
export const recommend = (params) => {
  return http.fetchGet('/front/goods/recommend', params)
}
// 捐赠板块
export const thank = (params) => {
  return http.fetchGet('/front/goods/thank', params)
}
// 极验验证码
export const geetest = (params) => {
  return http.fetchGet('/front/member/geetestInit?t=' + (new Date()).getTime(), params)
}
// h保存客户设计案例
export const saveProposal = (params) => {
  return http.fetchPost('/picSearch/wes/design-proposal/saveProposal', params)
  // return http.fetchPost('/front/member/register', params)
}

// h保存客户设计案例
export const deleteProposal = (params) => {
  return http.fetchPost('/picSearch/wes/design-proposal/deleteProposal', params)
  // return http.fetchPost('/front/member/register', params)
}

// 修改客户设计名称
export const modifyDesignName = (params) => {
  return http.fetchPost('/picSearch/wes/design-proposal/modifyDesignName', params)
  // return http.fetchPost('/front/member/register', params)
}

// 获取客户设计案例数据
export const getProposalData = (params) => {
  return http.fetchPost('/picSearch/wes/design-proposal/getProposalData', params)
  // return http.fetchPost('/front/member/register', params)
}
// 获取批注标签数据
export const getMarksByProposal = (params) => {
  return http.fetchPost('/picSearch/wes/design-proposal/getMarksByProposal', params)
  // return http.fetchPost('/front/member/register', params)
}
// 获取方案选中面料列表
export const getProposalFabrics = (params) => {
  return http.fetchPost('/picSearch/wes/design-proposal/getProposalFabrics', params)
}
// 获取方案选中花型列表
export const getProposalDecorates = (params) => {
  return http.fetchPost('/picSearch/wes/design-proposal/getProposalDecorates', params)
}
export const getMenuTree = () => {
  return http.fetchGet('/picSearch/wes/menu/getFrontMenuTree')
  // return http.fetchPost('/front/member/register', params)
}
export const uploadImg = (data) => {
  return http.fetchPost('/picSearch/wes/image/upload', data)
  // return http.fetchPost('/front/member/register', params)
}

export const uploadCustomerLogo = (data) => {
  return http.fetchPost('/picSearch/wes/image/uploadCustomerLogo', data)
  // return http.fetchPost('/front/member/register', params)
}

export const updateByUser = (data) => {
  return http.fetchPost('/picSearch/wes/customer/updateByUser', data)
  // return http.fetchPost('/front/member/register', params)
}

// h获取菜单
export const getSuggestKeys = (params) => {
  return http.fetchPost('/picSearch/wes/product/getSuggestKeys', params)
  // return http.fetchPost('/front/member/register', params)
}

export const getFabricDefact = (params) => {
  return http.fetchPost('/picSearch/wes/product/getFabricDefact', params)
  // return http.fetchPost('/front/member/register', params)
}

export const newapitest = (params) => {
  return http.fetchGet('/fapi/outsourced_project', params)
  // return http.fetchPost('/front/member/register', params)
}

// 获取VR展厅列表（用户端）
export const getVrChanelShowList = (params) => {
  return http.fetchPost('/picSearch/wes/vr-chanel/getVrChanelShowList', params)
}

export { apiWap, apiAiCreate }



// WEBPACK FOOTER //
// ./src/api/index.js